import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { stepsConfig } from "../step-config";
import { useStepCompletion } from "../hooks/useStepCompletion";
import { createAxiosInstance } from "../../../api";
import { useSelector } from "react-redux";
import "./StepHeader.css";

type Props = {
  activeIndex: number;
};

export default function StepHeader({ activeIndex }: Props) {
  const completions = useStepCompletion();
  const userId = useSelector((state: any) => state.main?.userId);
  const [hasSubjects, setHasSubjects] = useState(false);

  useEffect(() => {
    if (!userId) return;
    createAxiosInstance()
      .get(`${process.env.REACT_APP_SERVER}/api/subjects/user/${userId}`)
      .then((res) => {
        const subjects = res.data || [];
        setHasSubjects(subjects.length > 0);
      })
      .catch(() => setHasSubjects(false));
  }, [userId]);

  // Update completions with actual subjects status
  const updatedCompletions = {
    ...completions,
    subjects: { ...completions.subjects, isCompleted: hasSubjects },
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto" }}>
      <div className="onb-steps">
        {stepsConfig.map((s, i) => {
          const status = updatedCompletions[s.id as keyof typeof updatedCompletions];
          const isCompleted = status?.isCompleted || false;
          const isBeforeActive = i < activeIndex;
          const showCheckmark = isCompleted && i !== activeIndex;
          
          return (
            <div 
              key={s.id} 
              className={`onb-step ${isCompleted ? 'completed' : ''} ${i === activeIndex ? 'active' : ''}`}
            >
              <div className={`onb-line ${isBeforeActive && isCompleted ? 'completed-line' : ''}`} />
              <div className="onb-dot">
                {showCheckmark ? '✓' : i + 1}
              </div>
              <div className="onb-label">{s.title}</div>
            </div>
          );
        })}
      </div>
    </Box>
  );
}


